import React from 'react';
import { oneOf, oneOfType, number, string } from 'prop-types';
import cx from 'classnames';

import { getResponsivePropType, genResponsiveClasses } from './../../utils/';

import { Button, Icon, Grid, GridCol } from './../';
import { useLocale } from '../../modules/Internationalization';

const propTypes = {
  /** Pagination variant */
  variant: oneOf(['gallery', 'cards']),
  /** Pagination link */
  link: string,
  /** Grid size of actions */
  size: getResponsivePropType(
    oneOfType([number, oneOf(['shrink', 'fill', 'auto'])])
  ),
  /** Grid offset of actions */
  offset: getResponsivePropType(
    oneOfType([number, oneOf(['shrink', 'fill', 'auto', 'center'])])
  ),
  /** What element edge should fix to slider */
  fixedEdge: getResponsivePropType(oneOf(['bottom', 'top'])),
};

const defaultProps = {
  offset: { l: 6 },
  size: { xs: 22, m: 12, l: 6 },
  fixedEdge: 'bottom',
};

const CLASS_ROOT = 'slider__pagination';

const Pagination = ({
  className,
  children,
  variant,
  link,
  offset,
  size,
  fixedEdge,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${variant}`]: variant,
    },
    ...genResponsiveClasses(CLASS_ROOT, fixedEdge, 'fixed'),
    className
  );

  const locale = useLocale();

  // TODO: find a better place for textContent because here we are mixing component logic with hard coded text
  const textContent = {
    previousSlide: {
      sk: 'Nasledujúci slide',
      en: 'Previous slide',
    },
    nextSlide: {
      sk: 'Predchadzajúci slide',
      en: 'Next slide',
    },
    viewAll: {
      sk: 'Zobraziť všetko',
      en: 'View All',
    },
  };

  const actions = (
    <div
      className={`${CLASS_ROOT}__actions h6 ${
        variant === 'gallery' ? 'mt-none' : ''
      }`}
    >
      <Button size="small" padded className={`${CLASS_ROOT}__prev`}>
        <Icon size="large" name="arrow-left" />
        <span className="sr-only">{textContent.previousSlide[locale]}</span>
      </Button>
      {link ? (
        <Button size="small" className={`${CLASS_ROOT}__link`} href={link}>
          {textContent.viewAll[locale]}
        </Button>
      ) : (
        <span className={`${CLASS_ROOT}__counter`} />
      )}
      <Button size="small" padded className={`${CLASS_ROOT}__next`}>
        <Icon size="large" name="arrow-right" />
        <span className="sr-only">{textContent.nextSlide[locale]}</span>
      </Button>
    </div>
  );

  return (
    <Grid className={classes} {...other}>
      <GridCol offset={offset} size={size} className="pl-none pr-none">
        {actions}
      </GridCol>
      {variant === 'gallery' && (
        <GridCol className={cx(`${CLASS_ROOT}__description`)} size="fill" />
      )}
    </Grid>
  );
};

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Slider/SliderPagination.js